<template>
    <div class="stakePad">
        <div class="stakePad-row">
            <button
                v-for="(amount, index) in quickAmounts"
                v-bind:key="amount"
                class="stakePad-key"
                v-bind:class="`${gaClassPrefix}_Btn_StakePad_Shortcut${index}`"
                type="button"
                v-bind:data-testid="`quick-add-${amount}`"
                v-on:mousedown.prevent
                v-on:click="emit('addAmount', amount)"
            >
                +{{ formatMoney(amount) }}
            </button>
            <button
                class="stakePad-key _clear"
                v-bind:class="`${gaClassPrefix}_Btn_StakePad_Close`"
                data-testid="stake-clear"
                type="button"
                aria-label="Close"
                v-on:mousedown.prevent
                v-on:click="emit('close')"
            >
                <SboIcon name="system:cross" />
            </button>
        </div>
        <div class="stakePad-row">
            <button
                v-for="digit in digits"
                v-bind:key="digit"
                class="stakePad-key"
                v-bind:class="`${gaClassPrefix}_Btn_StakePad_Keybtn`"
                v-bind:data-keybtn="digit"
                type="button"
                v-bind:data-testid="`stake-key-${digit}`"
                v-on:mousedown.prevent
                v-on:click="emit('appendDigits', digit)"
            >
                {{ digit }}
            </button>
        </div>
        <div class="stakePad-row">
            <button
                v-for="digit in zeroDigits"
                v-bind:key="digit"
                class="stakePad-key"
                v-bind:class="`${gaClassPrefix}_Btn_StakePad_Keybtn`"
                v-bind:data-keybtn="digit"
                type="button"
                v-bind:data-testid="`stake-key-${digit}`"
                v-on:mousedown.prevent
                v-on:click="emit('appendDigits', digit)"
            >
                {{ digit }}
            </button>
            <button
                class="stakePad-key"
                v-bind:class="`${gaClassPrefix}_Btn_StakePad_Max`"
                data-testid="stake-max"
                type="button"
                v-on:mousedown.prevent
                v-on:click="emit('max')"
            >
                {{ i18n.t('stakePad_button_max') }}
            </button>
            <button
                class="stakePad-key _backspace"
                v-bind:class="`${gaClassPrefix}_Btn_StakePad_Backspace`"
                data-testid="stake-backspace"
                type="button"
                aria-label="Backspace"
                v-on:mousedown.prevent
                v-on:click="emit('backspace')"
            >
                <SvgIcon iconName="systemIcon_delete" />
            </button>
        </div>
        <SwitchAcceptAnyOddsValue
            v-if="customerInfo.isAcceptAnyOdds"
            class="stakePad-acceptAnyOdds"
        />
    </div>
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import SwitchAcceptAnyOddsValue from '@/components/SwitchAcceptAnyOddsValue.vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import { getQuickStakeAmounts } from '@/libraries/helpers/stakeInputHelper';
    import { i18n } from '@/libraries/i18n';
    import { useAccountStore } from '@/stores/accountStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    withDefaults(defineProps<{
        gaClassPrefix?: string;
    }>(), {
        gaClassPrefix: '',
    });

    const emit = defineEmits<{
        appendDigits: [digits: string];
        addAmount: [amount: number];
        max: [];
        backspace: [];
        close: [];
    }>();

    const { customerInfo } = storeToRefs(useAccountStore());
    const { formatMoney } = useAccountStore();

    const quickAmounts = computed(() => getQuickStakeAmounts(customerInfo.value.currency));

    const digits = Object.freeze(['1', '2', '3', '4', '5', '6', '7', '8', '9']);
    const zeroDigits = Object.freeze(['0', '00']);
</script>

<style lang="scss" scoped>
@import "@/scss/components/singleMode/stakePad";
</style>
